<template>
    <div style="float: right;">
        <template v-for="(item) in relatedModules">
            <a :href="getUrl(item)" target="_blank">
                <span v-if="item.title" :class="getIconClass(item)" v-popover:tooltip="t(item.title)"></span>
                <span v-else :class="getIconClass(item)"></span>
            </a>
        </template>
    </div>
</template>

<script>

import UrlResolver from "@/services/UrlResolver";

export default
{
    components: {},
    props: {
        config: {
            type: Object,
            default: function() {
                return {
                    allowedModules: [],
                    showValue: true,
                }
            },
        },
        column: {
            type: Object,
        },
        eventBus: {
            type: Object,
        },
        routeName: {
            type: String
        },
        row: {
            type: Object,
        }
    },
    data() {
        return {
            loading: false,
            relatedModules: [],
            url: null,
        };
    },
    computed: {
    },
    mounted() {
        this.loading = true;
        let dataLoader = this.eventBus.getDataLoader(this.config);
        dataLoader.bindEvents(this.setAvailableValues);
        dataLoader.load();
    },
    methods: {
        setAvailableValues(data) {
            this.relatedModules = data.filter(module => this.config.allowedModules.includes(module.label));
            this.loading = false;
        },
        getUrl(item) {
            if (0 === this.relatedModules.length) {
                return;
            }

            let url = item['url'];
            let query = {product: 'product_id'}

            return UrlResolver.resolveUrl(url, this.row, query, {});
        },
        getIconClass(item) {
            return 'related-module ' + item['icon_class'];
        }
    }
}
</script>

<style lang="sass" scoped>
@import "../../../node_modules/vue-slider-component/theme/default.css";
@import "src/assets/scss/variable.scss";
    .related-module {
        background-color: $main-background-color!important;
        margin-right: 3px;
    }
    .related-module:hover {
        background-color: green!important;
    }
</style>


// WEBPACK FOOTER //
// RelatedModulesComponent.vue?b44ba452